import { useTheme } from "@emotion/react";
import {
    Grid,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import GaugeChart from "react-gauge-chart";
import { useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCookiesLogin } from "../../config/cookies";
import { HOST_SINGED } from "../../config/hosts";
import { tokens } from "../../theme";

const regexCEP = /^(\d{5})(\d{3})$/;
const regexCPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const regexPhone = /^(\d{2})(\d{1})?(\d{4})(\d{4})$/;

const HandlerSerasaSocorePj = ({
  cpfcnpj,
  idConsult,
  tokenBrain,
}) => {
  const [name, setName] = useState("");
  const [taxIdNumber, setTaxIdNumber] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [taxIdOrigin, setTaxIdOrigin] = useState("");
  const [score, setScore] = useState("");
  const [eventProbability, setEventProbability] = useState("");

  const { cookies } = useCookiesLogin();
  const { id, bussines_id } = cookies.BRAUM_TOKEN;

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const navigateToDashboard = () => navigate("/app");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

    // já existe a consulta
    useEffect(() => {
        async function handleGetInfo() {
            const request = await fetch(`${HOST_SINGED}/brain/info/get`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
                body: JSON.stringify({
                    id_consult: idConsult,
                    token_brain: tokenBrain,
                }),
            });
        
            const response = await request.json();
            console.log(response, "response");

            const basic_info = response.datasets.filter(
                (data) => data.type === "BASIC_INFO"
            );
            const serasa_score = response.datasets.filter(
                (data) => data.type === "AGRO_SCORE_CNPJ"
            );

            if ((basic_info && serasa_score) == undefined) {
                alert("Ops! verifique os dados e tente novamente");
                console.info(
                    "Consulta não foi executada com sucesso datasets: " +
                    "basicinfo" +
                    "serasascore"
                );
            }

            if (serasa_score.length !== 0) {
                setEventProbability(serasa_score[0].results[0].event_probability);
                setScore(serasa_score[0].results[0].score);
                setTaxIdOrigin(basic_info[0].results[0].basicData.taxIdOrigin);
                setName(basic_info[0].results[0].basicData.name);

                // format date
                let timestamp = basic_info[0].results[0].basicData.birthDate;

                let date = new Date(timestamp);

                // Extract the components of the date
                var dayBirth = date.getDate();
                var monthBirth = date.getMonth() + 1; // Months are zero-based, so we add 1
                var yearBirth = date.getFullYear();

                var formattedBirthDate = `${dayBirth
                    .toString()
                    .padStart(2, "0")}/${monthBirth
                        .toString()
                        .padStart(2, "0")}/${yearBirth}`;

                setBirthDate(formattedBirthDate);
            }
        }
        handleGetInfo();
    }, [idConsult, tokenBrain]);

  return (
    <>
      <ToastContainer />
        <Grid container spacing={4} marginBottom={3} marginTop={5}>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Documento
            </Typography>
            <Typography fontSize={22}>
              {taxIdNumber.replace(regexCPF, "$1.$2.$3-$4")}
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Nome
            </Typography>
            <Typography fontSize={22}>{name}</Typography>
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Data de Nascimento
            </Typography>
            <Typography fontSize={22}>{birthDate}</Typography>
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Origem Dados
            </Typography>
            <Typography fontSize={22}>{taxIdOrigin}</Typography>
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Score
            </Typography>
            <Typography
              color={
                score < 333 ? "#ff5050" : score < 666 ? "#fff28b" : "secondary"
              }
              fontSize={22}
            >
              {score}
            </Typography>

            <GaugeChart
              id="gauge-chart2"
              nrOfLevels={20}
              percent={score / 1000}
              textColor="#f1f1f1"
              arcWidth={0.2}
              colors={["#FF0000", "#00FF00"]}
              formatTextValue={(value) => score}
              style={{
                fontWeight: 600,
              }}
            />
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Porcentagem de risco
            </Typography>
            <Typography fontSize={22}>
              {parseFloat(eventProbability * 100).toFixed(2)} %
            </Typography>
          </Grid>
        </Grid>
    </>
  );
};

export default HandlerSerasaSocorePj